import React, { useState } from 'react';

import Sidebar from '../../partials/Sidebar';
import Header from '../../partials/Header';
// import FilterButton from '../components/DropdownFilter';
// import Datepicker from '../components/Datepicker';
// import DashboardCard10 from '../partials/dashboard/DashboardCard10';
import DashboardCard14 from '../../partials/dashboard/DashboardCard14';
import Banner from '../../partials/Banner';
import { useNavigate } from "react-router-dom";


function Cities() {

    const [sidebarOpen, setSidebarOpen] = useState(false);
    const navigate = useNavigate();

    const handleNewRows = (item) => {
        //////////////////////////////console.log(item);
    
       navigate("/createuser");
      };

    return (
        <div className="flex h-screen overflow-hidden">

            {/* Sidebar */}
            <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            {/* Content area */}
            <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
                {/*  Site header */}
                <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                <main className="grow">
                    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
                        {/* Dashboard actions */}
                    

                        {/* Cards */}
                        <div className="grid grid-cols-12 gap-1 xs:pb-10 justify-center items-center">


                            {/* Card (Customers) */}
                             <DashboardCard14 /> 


                        </div>

                    </div>
                </main>

                <Banner />

            </div>
        </div>
    );
}

export default Cities;